import { Component, OnDestroy, OnInit } from '@angular/core';
import { NewRecipientModel } from '@pg-app/client/manage-recipient/models/recipient.model';
import { UserService } from '@pg-app/partner/user-profile/services/user-service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';
import { AddRecipientFrom } from '@pg-app/client/manage-recipient/constants/add-recipient-constants';
import { AddBeneficiaryStep } from '@pg-app/client/manage-recipient/constants/add-beneficiary-constant';

@Component({
  selector: 'np-bank-account-details',
  templateUrl: './bank-account-details.component.html',
  styleUrls: ['./bank-account-details.component.scss']
})
export class BankAccountDetailsComponent implements OnInit, OnDestroy {
  action = AddRecipientFrom.Bank;
  step = AddBeneficiaryStep;
  bankDto = null;
  bankId = null;
  isLoading = true;

  constructor(
    public newRecipientModel: NewRecipientModel,
    private userProfileService: UserService,
    private dialog: MatDialog,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.getUserDetail();
  }

  getUserDetail() {
    this.userProfileService.getUserDetail().subscribe(res => {
      if (res.bank) {
        this.bankDto = res.bank;
        this.bankId = res.bank.id;
        this.newRecipientModel.step1.country.id = res.bank.countryId;
        this.newRecipientModel.step1.currency.id = res.currencyId;
      }
      this.isLoading = false;
    });
  }

  updatePartnerBank() {
    const params = {
      currencyId: this.newRecipientModel.step1.currency.id,
      bankId: this.bankId ? this.bankId : null,
      bank: {
        id: this.bankId ? this.bankId : null,
        name: this.newRecipientModel.step2.bankName,
        accountNumber: this.newRecipientModel.step2.accountNumber || null,
        address1: this.newRecipientModel.step2.address1,
        address2: this.newRecipientModel.step2.address2 || null,
        address3: this.newRecipientModel.step2.address3 || null,
        city: this.newRecipientModel.step2.city || null,
        province: this.newRecipientModel.step2.stateProvince || null,
        postCode: this.newRecipientModel.step2.zipPostalCode || null,
        countryId: this.newRecipientModel.step1.country.id || null,
        iBan: this.newRecipientModel.step2.IBAN || null,
        reference: this.newRecipientModel.step2.reference || null,
        sWiftCode: this.newRecipientModel.step2.SWIFTCode || null,
        sortCodeUK: this.newRecipientModel.step2.sortCode || null,
        bankCode: this.newRecipientModel.step2.bankCode || null,
        bankAccountType: this.newRecipientModel.step2.bankAccountType,
      }
    };
    this.userProfileService.updateUserDetail(params).subscribe(
      data => {
        const dialogRef = this.dialog.open(CommonDialogComponent, {
          disableClose: true,
          data: {
            title: 'Payment details saved successfully',
            dialogType: 1,
            routingUrl: 'partner/user-profile'
          }
        });
        dialogRef.afterClosed().subscribe(res => {
          this.newRecipientModel.clear();
        });
      }
    );
  }

  ngOnDestroy() {
    this.newRecipientModel.clear();
  }
}
